<template>
    <form-template>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Phone Number</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input placeholder="Input Phone Number" />
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Carrier Network</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-4 gap-3 w-full">
                <div class="col-span-2 md:col-span-1" v-for="cable in cables" :key="cable.value">
                    <biller-radio
                        @select="selectedCable = cable.value"
                        :value="cable.value"
                        :active="selectedCable === cable.value"
                        class="flex items-center justify-center"
                    >
                        <div class="flex items-center justify-center">
                            <img :src="require(`@/assets/svg/${cable.value}.svg`)" class="mx-auto pr-3" />
                            <p :class="`text-sm ${selectedCable === cable.value ? 'text-purple' : 'text-grey-300'}`">
                                {{ cable.slug }}
                            </p>
                        </div>
                    </biller-radio>
                </div>
            </div>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Amount</p>
        </div>
        <div class="col-span-4 md:col-span-3 relative">
            <biller-input placeholder="Input Airtime Amount" largeValue>
                <template v-slot:append>
                    <img src="@/assets/svg/naira-icon.svg" alt="" />
                </template>
            </biller-input>
        </div>
    </form-template>
</template>

<script>
export default {
    name: 'Ghana',
    data() {
        return {
            selectedCable: '',
            cables: [
                {
                    value: 'airtel',
                    slug: 'Airtel',
                },
                {
                    value: 'tigo',
                    slug: 'Tigo',
                },
                {
                    value: 'mtn',
                    slug: 'MTN',
                },
                {
                    value: 'vodafone',
                    slug: 'Vodafone',
                },
            ],
        }
    },
}
</script>

<style></style>
